export default {
	"vehicleType": {
		"vehicletypeCode": "Model code",
		"vehicleLoad": "Model load",
		"vehicleType": "Model type",
		"cubage": "Model volume",
		"updateUser": "updater",
		"uploadDt": "update time",
		"vehicleInformation": "Model information",
		"vehicleLength": "vehicleLength",
		"vehicleWidth": "vehicleWidth",
		"vehicleHeight": "vehicleHeight"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/vehicleType/vehicleType.js